import { Grid } from "@mui/material";
import { Fragment, useState } from "react";

import List from "./List";
import { PageHeader } from "../../../components";
import AddNewAgentDialog from "./AddNewAgentDialog";
import { CreateButton } from "../../css components/Button";

export default function Form({ setColumns, setAgents, columns, agents }) {
  const [dialogState, setDialogState] = useState({ state: false, data: {} });

  return (
    <Fragment>
      <Grid container spacing={2}>
        <Grid size={12}>
          <PageHeader
            pageName={"Delivery Channel Agents"}
            pageHeader="View and manage agents assigned to each communication channel."
            buttons={[
              <CreateButton
                variant="contained"
                onClick={() =>
                  setDialogState({ state: true, agents: agents, create: true })
                }
              >
                Add New Agent
              </CreateButton>,
            ]}
          />
        </Grid>

        <Grid size={12} style={{ marginTop: "10px" }} />

        {agents?.map((agent) => (
          <Grid size={12} key={agent.channelID}>
            <List
              name={agent.channelName}
              agent={agent[agent.channelName]}
              fields={columns[agent.channelID]}
              setDialogState={setDialogState}
              agentInfo={{
                agentName: agent.channelName,
                logo: agent.channelLogo,
              }}
            />
          </Grid>
        ))}
      </Grid>

      <AddNewAgentDialog
        setColumns={setColumns}
        setAgents={setAgents}
        dialogState={dialogState}
        setDialogState={setDialogState}
      />
    </Fragment>
  );
}
